export const status = {
  "EM ANDAMENTO": "Em andamento",
  "AGUARDANDO ATIVACAO": "Aguardando ativação",
  ASSET_AGUARDANDO_ATIVACAO: "Aguardando ativação",
  ATIVO: "Ativo",
  "EM ASSET_ATIVO": "Ativo",
  "EM INATIVO": "Inativo",
  "EM ASSET_INATIVO": "Inativo",
  "EM EXECUÇÃO": "Em execução",
  "EM ELABORAÇÃO": "Em elaboração",
  "EM CANCELAMENTO": "Em cancelamento",
  INTERROMPIDO: "Interrompido",
  CANCELADO: "Cancelado",
  EM_ANALISE: "Em análise",
  NOVA: "Nova",
  AGUARDANDO: "Aguardando",
  ENCERRADA: "Encerrada"
}

export const selectStatusColor = (type) => {
  switch (type) {
    case "EM ANDAMENTO":
    case "AGUARDANDO ATIVACAO":
    case "ASSET_AGUARDANDO_ATIVACAO":
    case "EM_ANALISE":
      return "loading"

    case "ATIVO":
    case "ASSET_ATIVO":
    case "NOVA":
      return "success"

    case "INATIVO":
    case "ASSET_INATIVO":
    case "AGUARDANDO":
      return "cancel"

    case "EM EXECUÇÃO":
      return "schedule"

    case "EM ELABORAÇÃO":
      return "reschedule"

    case "EM CANCELAMENTO":
    case "INTERROMPIDO":
      return "suspended"

    case "CANCELADO":
    case "ENCERRADA":
      return "disapproved"

    default:
      return "default"
  }
}

export const TEXT_ACTION_SUCCESS = {
  "Reagendar portabilidade":
    "Solicitação concluída com sucesso, suas portabilidades foram reagendadas. <br><b>Reagendamento feito com sucesso!</b>",
  "Suspender portabilidade":
    "Solicitação concluída com sucesso, as portabilidades foram suspensas.",
  "Cancelar portabilidade":
    "Solicitação de cancelamento foi registrada e está sendo avaliada.",
  "Editar cliente": "Os dados do cliente foram atualizados com sucesso!",
  "Exportar dados do cliente": "Os dados foram exportados com sucesso!"
}



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/constants.js